const ACTIVITIES_API = {
	ACTIVITIES: '/activities',
	ACTIVITY: (id: number) => `/activities/${id}`,
	ACTIVITY_CATEGORIES: '/activity-categories',
	// LMS activities available for course mapping (per external LMS instance).
	LMS_INSTANCE_ACTIVITIES: '/lms-instance-activities',
	CHECK_ASSIGNMENT_NAME: '/assignment-sources/name-exists',
	ASSIGNMENT_DETAILS: '/assignment-sources'
};

export default ACTIVITIES_API;
